import React, { Component } from "react";
import Comment from "../../../../common/comments/comment.component";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loading } from "../../../../../components/common/loading";
import { disputeCommentActions } from '../../../../../store/external/invoice/dispute/dispute-comments.reducer';
import { MAX_LENGTH } from "../../../../../../app/constants/external-constants";


class DisputeComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        const { getInvoiceDisputeComments} = this.props;
        getInvoiceDisputeComments(this.props.disputeDetailsId, 1)
        .then(()=>{ this.setState({isLoading:false})
        });
    }

    componentWillUnmount() {
        this.props.clearInvoiceDisputeComments();
    }

    postComment = async (attachedFilename, attachedFileData, commentDescription) => {
        const { postInvoiceDisputeComments} = this.props;
        await postInvoiceDisputeComments(this.props.disputeDetailsId, attachedFilename, attachedFileData, commentDescription);  
    }

    handleDeleteDisputeComments = async (disputeDetailsId) => {
        this.setState({isLoading:true});
        const { deleteInvoiceDisputeComments, getInvoiceDisputeComments, clearInvoiceDisputeComments, invoiceDisputeComments } = this.props;

        await deleteInvoiceDisputeComments(disputeDetailsId);
        clearInvoiceDisputeComments();
        await getInvoiceDisputeComments(this.props.disputeDetailsId, 1, invoiceDisputeComments?.InvoiceDisputeComments?.length).then(()=>{
            this.setState({isLoading:false})
        });
        this.setState({show : false})
    }

    handleLoadMore = async () => {
        const { getInvoiceDisputeComments, invoiceDisputeComments } = this.props;
        await getInvoiceDisputeComments(this.props.disputeDetailsId, invoiceDisputeComments.pageIndex + 1)
    }


    render() {
        if (this.state.isLoading) {
            return <Loading />
        }
        const { roles } = this.props
        return (
            <div>
            <Comment
                commentList={this.props.invoiceDisputeComments.InvoiceDisputeComments}
                addCommentAction={this.postComment.bind(this)}
                deleteCommentAction={this.handleDeleteDisputeComments.bind(this)}
                maxLength={MAX_LENGTH.limit_500}
                isDisputeComment={true}
                handleLoadMore={this.handleLoadMore}
                hasMoreComments={this.props?.invoiceDisputeComments.hasMoreComments}
                {...roles}  
            />
            </div>
        )
    }
}

export default connect(
    state => {
        const { invoiceDisputeComments } = state;

        return {
            invoiceDisputeComments
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, disputeCommentActions),
        dispatch
    )
)(DisputeComment);
